export default function dotsNav() {
    function checkthedots() {
        let anchorPoints = document.querySelectorAll('main > section');
        // Reset all highlighted dots.
        let dots = document.querySelectorAll('.dots-nav > a');
        anchorPoints.forEach(function () {
            for (let dotIndex = 0; dotIndex < dots.length; dotIndex++) {
                let dotfill = dots[dotIndex];
                let target = document.getElementById('dot-selector-container');
                dotfill.classList.remove('active');
                target.classList.remove('dark_mode');
            };
        });

        // When a section is visible. Highlight only the relevant dot.
        let count = 0
        for (let anchor of anchorPoints) {
            let dotfill = dots[count];
            if (checkVisible(anchor) == true) {
                // Highlight the relevant dot and update the url bar
                dotfill.classList.add('active');
                // add darkmode class for sass to latch onto if section has the trigger
                if (dotfill.classList.contains('dark_trigger') == true) {
                    let target = document.getElementById('dot-selector-container');
                    target.classList.add('dark_mode');
                    break;
                };
                break;
            };
            count++;
        };
    };

    function checkVisible(anchor) {
        let rect = anchor.getBoundingClientRect();
        let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        // Here are some console logs that explain how this function works.
        // let testAnchor = document.getElementById("splash-news");
        // console.log("anchor: ", anchor);
        // if (testAnchor == anchor) {
        //     let statement1 = rect.bottom < 1;
        //     let statement2 = rect.top - viewHeight >= 0;
        //     let statement3 = rect.bottom < 1 || rect.top - viewHeight >= 0;
        //     let statement4 = !(rect.bottom < 1 || rect.top - viewHeight >= 0);
        //     console.log("rect.bottom(" + rect.bottom + ") < 1 == ", statement1);
        //     console.log("---OR---");
        //     console.log("rect.top(" + rect.top + ") - viewHeight(" + viewHeight + ") >= 0 == ", statement2);
        //     console.log("---SO---");
        //     console.log("return !(" + statement3 + "); == ", statement4)
        //     console.log("==================", '\n', '\n', '\n');
        // }
        return !(rect.bottom < 1 || rect.top - viewHeight >= 0);
    };

    window.onscroll = function() {
        checkthedots();
    }

    checkthedots();
}
